import { render, staticRenderFns } from "./buyerInformation.vue?vue&type=template&id=fd73dc2c&scoped=true&"
import script from "./buyerInformation.vue?vue&type=script&lang=js&"
export * from "./buyerInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd73dc2c",
  null
  
)

export default component.exports